import apiClient, { buildQueryParams } from '../utils/apiClient';
import { handleError } from '../utils/errorHandler';
import { API_ENDPOINTS } from '../constants/apiEndpoints.constants';

/**
 * Service for Vehicle Fuel Types API calls
 */
const vehicleFuelTypeService = {
  /**
   * Get all vehicle fuel types with pagination and filters
   */
  getAllFuelTypes: async (params = {}) => {
    try {
      const {
        page = 1,
        limit = 50,
        search = '',
        status = '',
        sortBy = 'createdAt',
        sortOrder = 'desc',
      } = params;

      const queryParams = buildQueryParams({
        page,
        limit,
        search,
        status,
        sortBy,
        sortOrder,
      });

      return await apiClient.get(`${API_ENDPOINTS.VEHICLE_FUEL_TYPES.LIST}?${queryParams}`);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.getAllFuelTypes'));
    }
  },

  /**
   * Get a single vehicle fuel type by ID
   */
  getFuelTypeById: async (id) => {
    try {
      return await apiClient.get(API_ENDPOINTS.VEHICLE_FUEL_TYPES.GET_BY_ID(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.getFuelTypeById'));
    }
  },

  /**
   * Create a new vehicle fuel type
   */
  createFuelType: async (fuelTypeData) => {
    try {
      return await apiClient.post(API_ENDPOINTS.VEHICLE_FUEL_TYPES.CREATE, fuelTypeData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.createFuelType'));
    }
  },

  /**
   * Update a vehicle fuel type
   */
  updateFuelType: async (id, fuelTypeData) => {
    try {
      return await apiClient.put(API_ENDPOINTS.VEHICLE_FUEL_TYPES.UPDATE(id), fuelTypeData);
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.updateFuelType'));
    }
  },

  /**
   * Delete a vehicle fuel type
   */
  deleteFuelType: async (id) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_FUEL_TYPES.DELETE(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.deleteFuelType'));
    }
  },

  /**
   * Delete multiple vehicle fuel types
   */
  deleteMultipleFuelTypes: async (ids) => {
    try {
      return await apiClient.delete(API_ENDPOINTS.VEHICLE_FUEL_TYPES.DELETE_MULTIPLE, { data: { ids } });
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.deleteMultipleFuelTypes'));
    }
  },

  /**
   * Toggle fuel type status
   */
  toggleFuelTypeStatus: async (id) => {
    try {
      return await apiClient.patch(API_ENDPOINTS.VEHICLE_FUEL_TYPES.TOGGLE_STATUS(id));
    } catch (error) {
      throw new Error(handleError(error, 'vehicleFuelTypeService.toggleFuelTypeStatus'));
    }
  },
};

export default vehicleFuelTypeService;
